<div class="modal-header">
    <h3 class="modal-title">
        NAICS Code Maintenance
        <i (click)="cancel()" class="fa fa-times pull-right"></i>
        <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px" (click)="minimise = !minimise"></i>
    </h3>
</div>
<div class="modal-body" [hidden]="minimise" style="padding-top: 0 !important;">
    @if (loader) {
<div class="gtw-naics-loader-overlay">
        <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
    </div>
}
    <div class="card">
        <div class="card-body container">
            <form [formGroup]="naicsForm" novalidate>
                <div class="row">
                    <div class="col-6">
                        <ap-field [title]="'Code'" [fieldId]="'1'" [disabled]="isEdit === true"
                            [error]="naicsForm.controls.code.status === 'INVALID'" [required]="true"
                            [ngClass]="{addBorder: naicsForm.controls.code.status === 'INVALID'}">
                    <input appkit-field formControlName="code"  aria-label="1" />
                        </ap-field>
                        @if (naicsForm.controls.code.status === 'INVALID') {
<div class="a-form-error">Enter a 6 digit numeric code</div>
}
                    </div>
                    <div class="col-6">
                        <ap-field [title]="'Code Description'" [fieldId]="'2'"
                            [error]="naicsForm.controls.codeDesc.status === 'INVALID'" [required]="true"
                            [ngClass]="{addBorder: naicsForm.controls.codeDesc.status === 'INVALID'}">
                    <input appkit-field formControlName="codeDesc"  aria-label="2" />
                        </ap-field>
                        @if (naicsForm.controls.codeDesc.status === 'INVALID') {
<div class="a-form-error">Enter description (max 100 characters)</div>
}
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="a-modal-footer modal-footer pad-zero">
        <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3" [btnType]="'primary'"
            (onClick)="cancel()">
        </ap-button>
        <ap-button [btnType]="'primary'" [label]="'SAVE'" class="ap-mr-spacing-3"
            (onClick)="insert()" [disabled]="naicsForm.status === 'INVALID'"></ap-button>
    </div>
</div>
